export default '/build/670cd41b.svg'